import i18n from "../../../i18n.ts"

const DETAIL_MESSAGE_KEYS: Record<string, string> = {
  not_pending: "accountDeletionRequests.errors.notPending",
  no_pending_request: "accountDeletionRequests.errors.notPending",
  not_processing: "accountDeletionRequests.errors.notProcessing",
  last_admin: "accountDeletionRequests.errors.lastAdmin",
  subscription_active: "accountDeletionRequests.errors.subscriptionActive",
  not_active: "accountDeletionRequests.errors.notActive",
  account_already_deleted: "accountDeletionRequests.errors.alreadyDeleted",
  feature_disabled: "accountDeletionRequests.errors.featureDisabled"
}

interface ErrorDetails {
  type: string
  message: string
  description: string | null
}

export const mapDeletionErrorDetails = (response: {
  data?: { details?: unknown; detail?: unknown }
}): unknown => {
  const details = response?.data?.details
  if (details) {
    return details
  }

  const code = response?.data?.detail
  if (typeof code !== "string") {
    return undefined
  }

  const key = DETAIL_MESSAGE_KEYS[code]
  const mapped: ErrorDetails = {
    type: "error",
    message: key ? i18n.t(key) : code,
    description: null
  }
  return mapped
}
